import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b0ef5a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "users-search-input" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsButton = _resolveComponent("AsButton")!
  const _component_AsBlock = _resolveComponent("AsBlock")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_UserListItem = _resolveComponent("UserListItem")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AsBlock, { class: "row-wrapper-space-between" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('users.title')), 1),
        _createVNode(_component_AsButton, {
          type: _ctx.buttonTypes.Primary,
          label: _ctx.$t('AddNew'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.createNewUser()))
        }, null, 8, ["type", "label"])
      ]),
      _: 1
    }),
    _createVNode(_component_AsBlock, { class: "users-search" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.usersSearch,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.usersSearch) = $event)),
              placeholder: _ctx.$t('users.searchPlaceholder'),
              style: {"width":"100%"}
            }, null, 8, ["modelValue", "placeholder"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: user.id
        }, [
          _createVNode(_component_UserListItem, {
            modelValue: _ctx.users[index],
            "onUpdate:modelValue": ($event: any) => ((_ctx.users[index]) = $event)
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]))
      }), 128))
    ])
  ], 64))
}